export const KEYS = {
  DEFAULT_TYPOGRAPHY_VARIANT: 'body1',
};
